import React from 'react';
import PromotionList from 'components/Content/PromotionList/PromotionList';
import { wrapFunctionalComponent } from 'utils/framework';

const PromotionListTrendingOffersHandler = restProps => <PromotionList {...restProps} />;

export default wrapFunctionalComponent(PromotionListTrendingOffersHandler, 'PromotionListTrendingOffersHandler');
